export const titleTextSize = 16;

export const labelTextSize = 13;

export const stampLabelSize = 12;
